module.exports = __webpack_public_path__ + "img/1.a847c530.png";